import { useEffect, useState } from "react";
import { PageHeader, Spinner, Card, EmptyState } from "@/components/dash";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";

export default function AdminWebhooks() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/webhooks").then(({ data }) => setItems(data.deliveries)).catch(() => setItems([])); }, []);
  if (!items) return <Spinner />;
  return (
    <div>
      <PageHeader title="Webhook İletimleri" desc="Platform genelindeki tüm webhook iletimleri." />
      {items.length === 0 ? <EmptyState title="İletim yok" /> : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-border bg-muted/40"><tr className="text-left text-xs text-muted-foreground">
                {["Olay", "URL", "Deneme", "Durum", "Tarih"].map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}
              </tr></thead>
              <tbody className="divide-y divide-border">
                {items.map((d) => (
                  <tr key={d.id} className="hover:bg-muted/30">
                    <td className="px-4 py-3 font-mono text-xs">{d.event}</td>
                    <td className="px-4 py-3 text-xs truncate max-w-[200px]">{d.url}</td>
                    <td className="px-4 py-3">{d.attempts}</td>
                    <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full ${d.status === "delivered" ? "bg-emerald-500/10 text-emerald-500" : "bg-red-500/10 text-red-500"}`}>{d.status === "delivered" ? "İletildi" : "Başarısız"}</span></td>
                    <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">{formatDate(d.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
